export const CREATE = 'CREATE';
export const FETCH_ALL = 'FETCH_ALL';
